export const ROW_STYLE = `
.select-column {
    text-align: center;
}

.row-expand-button {
    cursor: pointer;
    text-align: center;
}

.clickable {
    cursor: pointer;
}
`;


// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/angular-4-data-table/src/components/row.style.ts